<template>
    <div class="modal fade a-modal" ref="modal" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content" v-if="live">
                <div class="modal-header">
                    <h1 class="modal-title">Acceso a {{ live.name }}</h1>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Cerrar"></button>
                </div>
                <div class="modal-body text-center">
                    <p class="a-muted mb-3">Los equipos entran escaneando el QR o escribiendo el código.</p>
                    <JoinCodeQR :code="live.join_code" :size="220" :path="mode == utils.APP_MODES.ONLINE ? '/join-season' : '/join'" />
                    <div v-if="mode == utils.APP_MODES.EVENT" class="text-start mt-4">
                        <label class="form-label" for="manager-event-link">Enlace para la pantalla grande (manager)</label>
                        <div class="input-group">
                            <input id="manager-event-link" class="form-control" readonly :value="manager_link" @click="$event.target.select()" />
                            <button class="btn btn-secondary" type="button" @click="copy(manager_link)"><i class="bi bi-clipboard"></i>Copiar</button>
                        </div>
                    </div>
                </div>
                <div class="modal-footer justify-content-between">
                    <button type="button" class="btn btn-ghost" v-if="is_admin" @click="regenerate" title="Invalida el código actual"><i class="bi bi-arrow-repeat"></i>Generar código nuevo</button>
                    <button type="button" class="btn btn-primary" data-bs-dismiss="modal">Hecho</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Modal } from 'bootstrap'
import utils from '@/../../shared/utils'
import JoinCodeQR from '@/components/JoinCodeQR.vue'

// The one way into an event: its join code/QR (and, in event mode, the link
// that turns a screen into the big "manager" display). Same code for every
// stage of the event, so stages don't need their own.
export default {
    name: 'EventQrModal',
    components: { JoinCodeQR },
    data(){
        return { utils, mode: window.MODE, season_id: null };
    },
    computed: {
        // Read live from the store: regenerating replaces the season object.
        live(){
            return (this.$store.state.game.seasons || []).find((s) => s.id == this.season_id) || null;
        },
        manager_link(){
            const base = (process.env.VUE_APP_PUBLIC_URL || window.location.origin).replace(/\/$/, '');
            return this.live && this.live.join_code ? base + '/login/' + this.live.join_code : '';
        },
        is_admin(){
            const user = this.$store.state.game.user;
            return !!user && user.role == utils.USER_ROLES.ADMINISTRATOR;
        }
    },
    mounted(){
        this.modal = new Modal(this.$refs.modal);
    },
    beforeUnmount(){
        if(this.modal) this.modal.dispose();
    },
    methods: {
        open(season){
            this.season_id = season.id;
            this.modal.show();
        },
        regenerate(){
            window.network.wso.send(JSON.stringify({action: window.RPC.REGENERATE_SEASON_JOIN_CODE, params: {season_id: this.season_id}}));
        },
        copy(text){
            navigator.clipboard.writeText(text).then(() => window.toast.success('Enlace copiado'));
        }
    }
}
</script>
